import * as React from "react"

const SettingsSlidersIcon = (props) => {
  const { fill, ...svgProps } = props

  const bFill = fill || 'url(#b)'
  const cFill = fill || 'url(#c)'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 21 21"
      {...svgProps}
    >
      <g clipPath="url(#a)">
        <rect width={19.5} height={19.5} x={0.75} y={0.75} fill="transparent" rx={8} />
        <path
          fill={bFill}
          d="M17 14.563H9.538a2.423 2.423 0 0 0-4.576 0H4a.812.812 0 1 0 0 1.624h.962a2.423 2.423 0 0 0 4.576 0H17a.812.812 0 1 0 0-1.625Zm-9.75 1.624a.812.812 0 1 1 0-1.624.812.812 0 0 1 0 1.624Zm9.75-6.5h-.962a2.423 2.423 0 0 0-4.576 0H4a.812.812 0 1 0 0 1.626h7.462a2.423 2.423 0 0 0 4.576 0H17a.812.812 0 1 0 0-1.625Zm-3.25 1.626a.812.812 0 1 1 0-1.625.812.812 0 0 1 0 1.624ZM4 6.438h.962a2.423 2.423 0 0 0 4.576 0H17a.812.812 0 1 0 0-1.625H9.538a2.423 2.423 0 0 0-4.576 0H4a.812.812 0 1 0 0 1.625Zm3.25-1.625a.812.812 0 1 1 0 1.624.812.812 0 0 1 0-1.624Z"
        />
        <path
          fill={cFill}
          d="M17 14.563H9.538a2.423 2.423 0 0 0-4.576 0H4a.812.812 0 1 0 0 1.624h.962a2.423 2.423 0 0 0 4.576 0H17a.812.812 0 1 0 0-1.625Zm-9.75 1.624a.812.812 0 1 1 0-1.624.812.812 0 0 1 0 1.624Zm9.75-6.5h-.962a2.423 2.423 0 0 0-4.576 0H4a.812.812 0 1 0 0 1.626h7.462a2.423 2.423 0 0 0 4.576 0H17a.812.812 0 1 0 0-1.625Zm-3.25 1.626a.812.812 0 1 1 0-1.625.812.812 0 0 1 0 1.624ZM4 6.438h.962a2.423 2.423 0 0 0 4.576 0H17a.812.812 0 1 0 0-1.625H9.538a2.423 2.423 0 0 0-4.576 0H4a.812.812 0 1 0 0 1.625Zm3.25-1.625a.812.812 0 1 1 0 1.624.812.812 0 0 1 0-1.624Z"
        />
      </g>
      <defs>
        <linearGradient
          id="b"
          x1={10.5}
          x2={10.5}
          y1={3.188}
          y2={17.813}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6D72F6" />
          <stop offset={0.438} stopColor="#AEB0FA" />
          <stop offset={1} stopColor="#EEEBFF" />
        </linearGradient>
        <linearGradient
          id="c"
          x1={10.5}
          x2={10.5}
          y1={3.188}
          y2={17.813}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6D72F6" />
          <stop offset={1} stopColor="#AEB0FA" />
        </linearGradient>
        <clipPath id="a">
          <rect width={19.5} height={19.5} x={0.75} y={0.75} fill="#fff" rx={8} />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SettingsSlidersIcon
